<template>
  <div id="app">
    <template v-if="!isScreen">
      <layout />
    </template>
    <template v-else>
      <screen-layout />
    </template>
  </div>
</template>

<script>
import watermark from 'watermark-dom'
import get from 'lodash/get'
import { mapState } from 'vuex'
import Layout from '@/layout/Layout/index.vue'
import ScreenLayout from '@/layout/ScreenLayout/index.vue'
import { Utils } from '@yld/yun-utils-common'
// import { BASE_URL.WG } from '@yld/yun-utils-host'

export default {
  name: 'App',
  components: {
    Layout,
    ScreenLayout
  },
  computed: {
    ...mapState({
      'user': state => state.user,
      'tenantId': state => state.user.tenantId
    }),
    // 是否需要菜单和头部布局
    isScreen() {
      return !!this.$route.meta.isScreen
    }
  },
  watch: {
    '$route': {
      deep: true,
      handler(val) {
        const name = this.user.name
        const cellPhone = Utils.substrAfter(get(this.user, 'userInfo.cellPhone'), 4)
        const str = [name, cellPhone].filter(v => v).join('(')
        this.$nextTick(() => {
          setTimeout(() => {
            watermark.init({
              watermark_txt: str + ')',
              watermark_color: 'black',
              watermark_fontsize: '14px',
              watermark_alpha: '0.07',
              watermark_x_space: 50,
              watermark_y_space: 10
            })
          }, 800)
        })
      }
    },
    'tenantId': {
      deep: true,
      handler(val) {
        var link = document.querySelector('link[rel*="icon"]')
        link.href = 'https://yldfiles.geekyum.com/fe/imgs/lht.ico'

        // 全球捷运定制
        // if (val && val === '578644382409543680') {
        //   link.href = 'https://yldfiles.geekyum.com/fe/imgs/worldex_favicon.ico'
        // } else if (val && val === '626474597625761792') {
        //   // 冠亚定制
        //   link.href = 'https://yldfiles.geekyum.com/fe/imgs/topasia_favicon.ico'
        // } else if (val && val === '857678803781554176') {
        //   // 立远定制
        //   link.href = 'https://lyfiless.oss-cn-shanghai.aliyuncs.com/fe/imgs/ly.ico'
        // } else if (val && val === '926434557044178944') {
        //   // 信腾
        //   link.href = 'https://geekfiles.oss-cn-shanghai.aliyuncs.com/fe/imgs/20250318-151021.ico'
        // } else if (val && val === '575306225098129408') {
        //   // 西格玛
        //   link.href = 'https://sigmafiles.oss-cn-shanghai.aliyuncs.com/fe/imgs/xigema_ico.ico'
        // } else {
        //   link.href = 'https://yldfiles.geekyum.com/fe/imgs/favicon.ico'
        // }
      }
    }
  }
}
</script>

<style lang="scss">
  body {
    font-family: 'Helvetica Neue', Helvetica, Arial, 'PingFang SC', 'Hiragino Sans GB', 'Heiti SC', 'Microsoft YaHei', 'WenQuanYi Micro Hei', sans-serif;
    font-size: 12px;
  }
  // html::-webkit-scrollbar, body::-webkit-scrollbar
  div::-webkit-scrollbar, span::-webkit-scrollbar{
    width: 8px;
    height: 8px;
    //background: #f1f2f3;
    cursor: pointer !important;
  }
  ::-webkit-scrollbar-thumb {
    background: #9999 !important;
    border-radius: 10px;
  }
</style>
